import { useMutation, UseQueryResult } from '@tanstack/react-query'
import { queryClient, QueryOptions, UseMutationResult, useResource, useResources } from '.'
import {
  create,
  fetch,
  get,
  Service,
  ServiceCreationPayload,
  ServiceUpdatePayload,
  update,
} from '../api/services'

export const serviceKeys = {
  create: ['services', 'create'] as const,
  update: ['services', 'update'] as const,
}

/**
 * Query hook for fetching a single service
 */
export const useServiceQuery = (
  id?: string,
  options?: QueryOptions<Service>,
): UseQueryResult<Service, any> => useResource<Service>('services', get, id, undefined, options)

/**
 * Query hook for fetching multiple services
 */
export const useServicesQuery = (
  filters?: any,
  options?: QueryOptions<Service[]>,
): UseQueryResult<Service[], any> =>
  useResources<Service[], any>('services', fetch, filters, options)

// Mutation success handler
const onMutationSuccess = () => {
  queryClient.invalidateQueries(['services'])
}

/**
 * Mutation hook for creating a service
 */
export const useCreateMutation = (): UseMutationResult<Service, ServiceCreationPayload> =>
  useMutation(create, { mutationKey: serviceKeys.create, onSuccess: onMutationSuccess })

/**
 * Mutation hook for updating a service
 */
export const useUpdateMutation = (): UseMutationResult<Service, ServiceUpdatePayload> =>
  useMutation(update, {
    mutationKey: serviceKeys.update,
    onSuccess: onMutationSuccess,
  })
